import React, { useContext } from 'react';
import { JobSearchContext } from './context';
import Container from './components/container/container';
import AlertPopup from '../components/react/alert_popup/alert_popup';

const JobSearch = () => {
  const { alertData, setAlertData } = useContext(JobSearchContext);
  return (
    <>
      <AlertPopup alertData={alertData} setAlertData={setAlertData} />
      <Container />
    </>
  );
};

export default JobSearch;
